export const handleDoesntMatter = (updateState, key, selectedValues) => {
  const hasDoesntMatter = selectedValues.includes("");

  if (hasDoesntMatter) {
    updateState((prev) => ({ ...prev, [key]: [""] }));
  } else {
    const cleanedValues = selectedValues.filter((item) => item.value !== "");
    updateState((prev) => ({ ...prev, [key]: cleanedValues }));
  }
};
